import Link from "next/link";
import { Button } from "@/components/ui/button";

export function Hero() {
  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 mb-6">
          The All-in-One Operations Platform <br className="hidden md:inline" />
          for Modern MSPs
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
          Streamline your managed services business with a unified platform for tickets, time
          tracking, client management, and reporting. Built by MSPs, for MSPs.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link href="https://westtn.consulting/en/contact" target="_blank">
            <Button size="lg" className="w-full sm:w-auto text-lg px-8 h-12">
              Request a Demo
            </Button>
          </Link>
          <Link href="#features">
            <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg px-8 h-12">
              Explore Features
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
